











import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getBaseInfoForSlide } from '../../services/graph/slide.graph';

@Component({
  components: {}
})
export default class ReferenceTileSlideLink extends Vue {
  @Prop({ type: String }) sid!: string | null;
  @Prop({ type: Boolean }) isLoading!: boolean;
  @Prop({ type: Boolean }) chip!: boolean;
  private slide: { name?: string; _id?: string; externalId?: string } | null = null;

  @Watch('sid', { immediate: true })
  onSidChange(sid: string | null) {
    if (sid) {
      getBaseInfoForSlide({ slideId: sid }).then(slide => {
        this.slide = slide;
      });
    }
  }
}
